import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=217a6391&scoped=true"
import script from "./UploadImg.vue?vue&type=script&lang=js"
export * from "./UploadImg.vue?vue&type=script&lang=js"
import style0 from "./UploadImg.vue?vue&type=style&index=0&id=217a6391&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217a6391",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\androidcode\\zf_tms_vue\\tms_vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('217a6391')) {
      api.createRecord('217a6391', component.options)
    } else {
      api.reload('217a6391', component.options)
    }
    module.hot.accept("./UploadImg.vue?vue&type=template&id=217a6391&scoped=true", function () {
      api.rerender('217a6391', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Generator/components/Upload/UploadImg.vue"
export default component.exports